export default __webpack_public_path__ + "static/media/avatar-s-1.04c3c579.jpg";